import axios, { AxiosRequestConfig } from "axios";
import {
  CreateColorCompanyData,
  CreateColorData,
  CreateModel,
  CreateModelCompany,
  CreateStorageLocation,
  CreateStorageLocationCompany,
  CreateVehicleData,
  CreateYearModel,
  CreateYearModelCompany,
  PaginatedVehicleData,
  PaginatedVehicleTransferData,
  TransferVehicleResponse,
} from "../types/vehicleData";
import { ClienteData } from "../types/clientData";

export const getVehicles = async (token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo`;

    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar veículos:", error);
    throw error;
  }
};

export const getVehiclesCompany = async (token: string, companyId: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo?id_empresa=${companyId}`;

    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar veículos da empresa:", error);
    throw error;
  }
};

export const createVehicle = async (
  token: string,
  vehicleData: CreateVehicleData
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo`;
    const response = await axios.post(url, vehicleData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar veículo:", error);
    throw error;
  }
};

export const getVehiclesNaoEntregue = async (
  token: string,
  selectedEmpresa: number | null,
  page: number = 1,
  cliente: boolean | null = null,
  startDateChecklist?: string,
  endDateChecklist?: string,
  startDateArmazenagem?: string,
  endDateArmazenagem?: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    let baseUrl = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo?entrega_veiculo=false&page=${page}`;

    if (cliente !== null) {
      baseUrl += `&cliente=${cliente}`;
    }

    const formattedStartDateChecklist = startDateChecklist
      ? new Date(startDateChecklist).toISOString().split("T")[0]
      : null;
    const formattedEndDateChecklist = endDateChecklist
      ? new Date(endDateChecklist).toISOString().split("T")[0]
      : null;

    if (formattedStartDateChecklist && formattedEndDateChecklist) {
      baseUrl += `&data_checklist_inicial=${formattedStartDateChecklist}&data_checklist_final=${formattedEndDateChecklist}`;
    }

    const formattedStartDateArmazenagem = startDateArmazenagem
      ? new Date(startDateArmazenagem).toISOString().split("T")[0]
      : null;
    const formattedEndDateArmazenagem = endDateArmazenagem
      ? new Date(endDateArmazenagem).toISOString().split("T")[0]
      : null;

    if (formattedStartDateArmazenagem && formattedEndDateArmazenagem) {
      baseUrl += `&data_armazenamento_inicial=${formattedStartDateArmazenagem}&data_armazenamento_final=${formattedEndDateArmazenagem}`;
    }

    const url = selectedEmpresa
      ? `${baseUrl}&id_empresa=${selectedEmpresa}`
      : baseUrl;

    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar veículos não entregues:", error);
    throw error;
  }
};

export const getVehiclesEntregues = async (
  token: string,
  selectedEmpresa: number | null,
  page: number = 1,
  cliente: boolean | null = null,
  startDateChecklist?: string,
  endDateChecklist?: string,
  startDateArmazenagem?: string,
  endDateArmazenagem?: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    let baseUrl = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo?entrega_veiculo=true&page=${page}`;
    if (cliente !== null) {
      baseUrl += `&cliente=${cliente}`;
    }

    const formattedStartDateChecklist = startDateChecklist
      ? new Date(startDateChecklist).toISOString().split("T")[0]
      : null;
    const formattedEndDateChecklist = endDateChecklist
      ? new Date(endDateChecklist).toISOString().split("T")[0]
      : null;

    if (formattedStartDateChecklist && formattedEndDateChecklist) {
      baseUrl += `&data_checklist_inicial=${formattedStartDateChecklist}&data_checklist_final=${formattedEndDateChecklist}`;
    }

    const formattedStartDateArmazenagem = startDateArmazenagem
      ? new Date(startDateArmazenagem).toISOString().split("T")[0]
      : null;
    const formattedEndDateArmazenagem = endDateArmazenagem
      ? new Date(endDateArmazenagem).toISOString().split("T")[0]
      : null;

    if (formattedStartDateArmazenagem && formattedEndDateArmazenagem) {
      baseUrl += `&data_armazenamento_inicial=${formattedStartDateArmazenagem}&data_armazenamento_final=${formattedEndDateArmazenagem}`;
    }

    const url = selectedEmpresa
      ? `${baseUrl}&id_empresa=${selectedEmpresa}`
      : baseUrl;

    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar veículos não entregues:", error);
    throw error;
  }
};

export const getColorsVehicle = async (token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cor`;
    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar cores:", error);
    throw error;
  }
};

export const getColorsVehicleCompany = async (
  token: string,
  companyId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cor?id_empresa=${companyId}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar cores para a empresa:", error);
    throw error;
  }
};

export const createColorVehicle = async (
  token: string,
  colorData: CreateColorData
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cor`;
    const response = await axios.post(url, colorData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar cor do veículo:", error);
    throw error;
  }
};

export const createColorVehicleCompany = async (
  token: string,
  colorData: CreateColorCompanyData,
  companyId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cor?id_empresa=${companyId}`;
    const response = await axios.post(url, colorData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar cor do veículo:", error);
    throw error;
  }
};

export const getModelsVehicle = async (token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/modelo`;
    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao modelo:", error);
    throw error;
  }
};

export const getModelsVehiclesCompany = async (
  token: string,
  companyId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/modelo?id_empresa=${companyId}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar modelos da empresa:", error);
    throw error;
  }
};

export const createModelVehicle = async (
  token: string,
  modelData: CreateModel
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/modelo`;
    const response = await axios.post(url, modelData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar modelo do veículo:", error);
    throw error;
  }
};

export const createModelVehicleCompany = async (
  token: string,
  modelData: CreateModelCompany
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/modelo`;
    const response = await axios.post(url, modelData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar modelo do veículo:", error);
    throw error;
  }
};

export const getModelYear = async (token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/ano/modelo`;
    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar ano modelo:", error);
    throw error;
  }
};

export const getModelYearVehiclesCompany = async (
  token: string,
  companyId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/ano/modelo?id_empresa=${companyId}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar ano / modelo para a empresa:", error);
    throw error;
  }
};

export const createModelYearVehicle = async (
  token: string,
  modelYearData: CreateYearModel
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/ano/modelo`;
    const response = await axios.post(url, modelYearData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar ano / modelo do veículo:", error);
    throw error;
  }
};

export const createModelYearVehicleCompany = async (
  token: string,
  modelYearData: CreateYearModelCompany,
  companyId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/ano/modelo?id_empresa=${companyId}`;
    const response = await axios.post(url, modelYearData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar modelo do veículo:", error);
    throw error;
  }
};

export const getStorageLocation = async (token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/local`;
    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar o local de armazenamento:", error);
    throw error;
  }
};

export const getStorageLocationCompany = async (
  token: string,
  companyId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/local?id_empresa=${companyId}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar o local de armazenamento da empresa:", error);
    throw error;
  }
};

export const getStorageType = async (token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/tipolocal`;
    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar o tipo do local de armazenamento:", error);
    throw error;
  }
};

export const createStorageLocation = async (
  token: string,
  modelStorageLocationData: CreateStorageLocation
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/local`;
    const response = await axios.post(url, modelStorageLocationData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar local de armazenagem do veículo:", error);
    throw error;
  }
};

export const createStorageLocationCompany = async (
  token: string,
  modelStorageLocationData: CreateStorageLocationCompany,
  companyId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/local?id_empresa=${companyId}`;
    const response = await axios.post(url, modelStorageLocationData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar local de armazenagem do veículo:", error);
    throw error;
  }
};

export const updateVehicle = async (
  token: string,
  id: string,
  vehicleData: Partial<CreateVehicleData>
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/${id}`;
    const response = await axios.put(url, vehicleData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar veículo:", error);
    throw error;
  }
};

export const getVehicleById = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar detalhes do veículo:", error);
    throw error;
  }
};

export const kmPhoto = async (
  idVeiculo: number,
  base64ImageData: string,
  token: string
) => {
  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/kmfoto`;
  const data = {
    id_veiculo: idVeiculo,
    data: base64ImageData,
  };

  try {
    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (response.status !== 200) {
      throw new Error("Erro ao enviar a foto para o banco de dados.");
    }
  } catch (error) {
    console.error("Erro ao enviar a foto para o banco de dados:", error);
    throw error;
  }
};

export const radioPhoto = async (
  idVeiculo: number,
  base64ImageData: string,
  token: string
) => {
  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/radiofoto`;
  const data = {
    id_veiculo: idVeiculo,
    data: base64ImageData,
  };

  try {
    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (response.status !== 200) {
      throw new Error(
        "Erro ao enviar a foto do Código de Rádio para o banco de dados."
      );
    }
  } catch (error) {
    console.error(
      "Erro ao enviar a foto do Código de Rádio para o banco de dados:",
      error
    );
    throw error;
  }
};

export const createVehicleWithClient = async (
  data: CreateVehicleData,
  token: string,
  clientId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cliente/${clientId}/veiculo`;
    const response = await axios.post(url, data, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao criar veículo:", error);
    throw error;
  }
};

export const createVehicleLinkClient = async (
  data: ClienteData,
  token: string,
  vehicleId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/${vehicleId}/${data.id}`;

    const response = await axios.put(url, data, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao vincular cliente ao veículo:", error);
    throw error;
  }
};

export const createVehicleLinkSeller = async (
  data: ClienteData,
  token: string,
  vehicleId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/vendedor/${data.id}/${vehicleId}`;

    const response = await axios.put(url, data, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao vincular vendedor ao veículo:", error);
    throw error;
  }
};

export const getVehiclesWithChecklistAtrasado = async (
  token: string,
  selectedEmpresa: number | null,
  page: number = 1,
  cliente: boolean | null = null,
  startDateChecklist?: string,
  endDateChecklist?: string,
  startDateArmazenagem?: string,
  endDateArmazenagem?: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    let baseUrl = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/checklist/atrasado?page=${page}`;

    if (cliente !== null) {
      baseUrl += `&cliente=${cliente}`;
    }

    const formattedStartDateChecklist = startDateChecklist
      ? new Date(startDateChecklist).toISOString().split("T")[0]
      : null;
    const formattedEndDateChecklist = endDateChecklist
      ? new Date(endDateChecklist).toISOString().split("T")[0]
      : null;

    if (formattedStartDateChecklist && formattedEndDateChecklist) {
      baseUrl += `&data_checklist_inicial=${formattedStartDateChecklist}&data_checklist_final=${formattedEndDateChecklist}`;
    }

    const formattedStartDateArmazenagem = startDateArmazenagem
      ? new Date(startDateArmazenagem).toISOString().split("T")[0]
      : null;
    const formattedEndDateArmazenagem = endDateArmazenagem
      ? new Date(endDateArmazenagem).toISOString().split("T")[0]
      : null;

    if (formattedStartDateArmazenagem && formattedEndDateArmazenagem) {
      baseUrl += `&data_armazenamento_inicial=${formattedStartDateArmazenagem}&data_armazenamento_final=${formattedEndDateArmazenagem}`;
    }

    const url = selectedEmpresa
      ? `${baseUrl}&id_empresa=${selectedEmpresa}`
      : baseUrl;

    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar veículos atrasados:", error);
    throw error;
  }
};

export const getVehiclesSemChecklist = async (
  token: string,
  selectedEmpresa: number | null,
  page: number = 1,
  cliente: boolean | null = null,
  startDateChecklist?: string,
  endDateChecklist?: string,
  startDateArmazenagem?: string,
  endDateArmazenagem?: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    let baseUrl = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/checklist/sem?page=${page}`;
    if (cliente !== null) {
      baseUrl += `&cliente=${cliente}`;
    }

    const formattedStartDateChecklist = startDateChecklist
      ? new Date(startDateChecklist).toISOString().split("T")[0]
      : null;
    const formattedEndDateChecklist = endDateChecklist
      ? new Date(endDateChecklist).toISOString().split("T")[0]
      : null;

    if (formattedStartDateChecklist && formattedEndDateChecklist) {
      baseUrl += `&data_checklist_inicial=${formattedStartDateChecklist}&data_checklist_final=${formattedEndDateChecklist}`;
    }

    const formattedStartDateArmazenagem = startDateArmazenagem
      ? new Date(startDateArmazenagem).toISOString().split("T")[0]
      : null;
    const formattedEndDateArmazenagem = endDateArmazenagem
      ? new Date(endDateArmazenagem).toISOString().split("T")[0]
      : null;

    if (formattedStartDateArmazenagem && formattedEndDateArmazenagem) {
      baseUrl += `&data_armazenamento_inicial=${formattedStartDateArmazenagem}&data_armazenamento_final=${formattedEndDateArmazenagem}`;
    }

    const url = selectedEmpresa
      ? `${baseUrl}&id_empresa=${selectedEmpresa}`
      : baseUrl;

    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar veículos sem checklist:", error);
    throw error;
  }
};

export const getImagesVehicle = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/fotos/veiculos/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao ver fotos do veículo:", error);
    throw error;
  }
};

export const transferLocalVehicle = async (
  vehicleId: number,
  companyId: number,
  locationId: number,
  descricao: string,
  token: string
): Promise<TransferVehicleResponse> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/transferencia/${vehicleId}/${companyId}/${locationId}`;

    const requestBody = {
      observacao_historico_transferencia_veiculo: descricao,
    };

    const response = await axios.post<TransferVehicleResponse>(
      url,
      requestBody,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Erro transferir veículo:", error);
    throw error;
  }
};

export const uploadCapturedImages = async (
  images: string,
  idTransferencia: number,
  token: string
) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_API_DOMAIN}/entrega/historico/fotos`,
      {
        id_historico_tranferencia_veiculo: idTransferencia,
        data: images,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (error) {
    console.error("Erro ao enviar fotos:", error);
  }
};

export const uploadSignedTransfer = async (
  transferencia: string,
  idTransferencia: number,
  nomeTranferencia: string,
  tipoTransferencia: number,
  documentoTransferencia: string,
  token: string
) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_API_DOMAIN}/entrega/historico/assinatura`,
      {
        id_historico_tranferencia_veiculo: idTransferencia,
        data: transferencia,
        nome_historico_transferencia_veiculo_assinatura: nomeTranferencia,
        tipo_historico_transferencia_veiculo_assinatura: tipoTransferencia,
        documento_historico_transferencia_veiculo_assinatura:
          documentoTransferencia,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (error) {
    console.error("Erro ao enviar assinatura:", error);
  }
};

export const searchVehicles = async (
  token: string,
  query: string,
  page: number = 1,
  cliente: boolean | null = null,
  companyId: number | null = null
): Promise<PaginatedVehicleData> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const params = new URLSearchParams();
    params.set("q", query);
    params.set("page", String(page));

    if (cliente !== null) {
      params.set("cliente", String(cliente));
    }

    if (companyId !== null) {
      params.set("id_empresa", String(companyId));
    }

    const baseUrl = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo?${params.toString()}`;
    const response = await axios.get(baseUrl, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar veículos:", error);
    throw error;
  }
};

export const getTransferVehicles = async (token: string, page: number = 1) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/transferencias?page=${page}`;

    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar veículos em transferência:", error);
    throw error;
  }
};

export const searchVehiclesTransfer = async (
  token: string,
  query: string,
  page: number = 1
): Promise<PaginatedVehicleTransferData> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    let baseUrl = `${process.env.REACT_APP_API_DOMAIN}/entrega/transferencias?q=${query}&page=${page}`;

    const response = await axios.get(baseUrl, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar veículos em tranferência:", error);
    throw error;
  }
};

export const transferVehicle = async (token: string, vehicleId: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/transferencias/${vehicleId}`;
    const response = await axios.post(url, {}, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao transferir veículo:", error);
    throw error;
  }
};

export const deleteVehicle = async (
  token: string,
  vehicleId: number
): Promise<void> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/${vehicleId}`;

    await axios.delete(url, config);
  } catch (error) {
    console.error("Erro ao excluir veículo:", error);
    throw error;
  }
};

export const fetchVehicleByVin = async (vin: string, token: string) => {
  try {
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/find/${vin}`;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar veículo pelo V.I.N.:", error);
    throw error;
  }
};

export const fetchVehicleByVinApiConfig = async (
  vin: string,
  token: string
) => {
  try {
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/busca/api/${vin}`;
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar veículo pela API externa (ApiConfig):",
      error
    );
    throw error;
  }
};

export const getChecklistAtrasadoExcel = async (
  token: string,
  id_empresa?: number | null
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    let url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/checklist/atrasado/excel`;
    if (id_empresa) {
      url += `?id_empresa=${id_empresa}`;
    }

    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar checklist atrasado (Excel):", error);
    throw error;
  }
};
